import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getAtBatState } from '../store/selectors/getAtBat';
import PitchFx from '@gameday/components/PitchFx/PitchFx';
import { routes as PitchFXRoutes } from '../../PitchFx/PitchFxDataContainer';

const FALLBACK_CONFIG = {};

const routes = [{
    routes: [
        ...PitchFXRoutes
    ]
}];

const AtBatPitchFxDataContainer = ({
    pitchFxConfig = FALLBACK_CONFIG,
    playIndex
}) => {
    const atBatState = useSelector(getAtBatState(playIndex));

    return (
        <PitchFx
            batterModel={atBatState.batterModel}
            isLoading={atBatState.isLoading}
            pitchFxConfig={pitchFxConfig}
        />
    );
};

AtBatPitchFxDataContainer.propTypes = {
    playIndex: PropTypes.number.isRequired,
    pitchFxConfig: PropTypes.object
};

export default AtBatPitchFxDataContainer;
export { routes };
